// Centralized route helpers for consistency and easy refactors

const ASC_MODE_KEY = 'mode';
const ASC_MODE_VALUE = 'asc';

export const isAscLoginPath = (pathname = '', search = '') => {
  if (!pathname) return false;
  if (pathname.startsWith('/asc/login')) return true;
  if (!pathname.startsWith('/login')) return false;
  try {
    const params = new URLSearchParams(search || (typeof window !== 'undefined' ? window.location.search : ''));
    return params.get(ASC_MODE_KEY) === ASC_MODE_VALUE;
  } catch {
    return false;
  }
};

const routes = {
  // UI routes
  login: (opts = {}) => {
    const mode = opts.mode;
    if (mode === 'patient' || mode === 'asc' || mode === 'hospital' || mode === 'staff') {
      // Map legacy 'staff' to 'hospital' for consistency
      const normalized = mode === 'staff' ? 'hospital' : mode;
      return `/login?mode=${normalized}`;
    }
    return '/login';
  },
  ascLogin: () => `/login?${ASC_MODE_KEY}=${ASC_MODE_VALUE}`,
  patientVerifyEmail: () => '/patient/verify-email',
  patientDashboard: () => '/patient/dashboard',
  orders: () => '/orders',
  reviewQueue: () => '/review-queue',
  ascReviewQueue: () => '/asc/review-queue',

  // API routes
  api: {
    featureFlags: () => '/api/feature-flags',
    orders: () => '/api/orders',
    order: id => `/api/orders/${id}`,
    orderApprove: id => `/api/orders/${id}/approve`,
    orderSend: id => `/api/orders/${id}/send`,
    orderTimeline: id => `/api/orders/${id}/timeline`,
    patientOrders: id => `/api/patients/${encodeURIComponent(id)}/orders`,
  },
};

routes.isAscLoginPath = isAscLoginPath;

export default routes;
